module.exports = __webpack_public_path__ + "img/marker.9ffb1c48.svg";